import React from "react";
import { Grid, CardContent, Typography } from "@mui/material";

import ProjectTypeCard from "./ProjectTypeComponent";
import SquareFootageCard from "./SquareFootageComponent";
import PriceSFCard from "./PricePerSFComponent";
import ProjectStageCardSmall from "./ProjectStatusSmallComponent";

const MasterProjectInfoCard = ({ projectData, onStageColorChange, budgetData }) => {
	return (
		<CardContent
			sx={{
				marginBottom: "-30px",
				marginTop: "-15px",
				marginLeft: "-20px",
				marginRight: "-20px",
			}}
		>
			<Grid
				container
				spacing={{ xs: 2 }}
				sx={{ width: "100%", justifyContent: "center" }}
			>
				<Grid size={{ xs: 4 }}>
					<Typography
						variant="subtitle1"
						className="card-title"
						sx={{ textAlign: "center" }}
					>
						Project Type
					</Typography>
					<ProjectTypeCard projectData={projectData} />
				</Grid>
				<Grid size={{ xs: 4 }}>
					<Typography
						variant="subtitle1"
						className="card-title"
						sx={{ textAlign: "center" }}
					>
						Project Status
					</Typography>
					<ProjectStageCardSmall
						projectData={projectData}
						onStageColorChange={onStageColorChange}
					/>
				</Grid>
				<Grid size={{ xs: 4 }}>
					<Typography
						variant="subtitle1"
						className="card-title"
						sx={{ textAlign: "center", marginBottom: "0px" }}
					>
						Square Footage
					</Typography>
					<span className="ppsf-container">
						<SquareFootageCard projectData={projectData} />
						<PriceSFCard projectData={projectData} budgetData={budgetData} />
					</span>
				</Grid>
			</Grid>
		</CardContent>
	);
};

export default MasterProjectInfoCard;
